export default __webpack_public_path__ + "static/media/protoconwallet-logo.41425e00.svg";